import { render } from "./GroupPresentationEvaluations.vue?vue&type=template&id=7373ce1c&scoped=true"
import script from "./GroupPresentationEvaluations.vue?vue&type=script&lang=js"
export * from "./GroupPresentationEvaluations.vue?vue&type=script&lang=js"

import "./GroupPresentationEvaluations.vue?vue&type=style&index=0&id=7373ce1c&scoped=true&lang=css"

import exportComponent from "F:\\online.ug\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7373ce1c"]])

export default __exports__